import { render, staticRenderFns } from "./GooglePlayChannels.vue?vue&type=template&id=3b5a29f6&scoped=true"
import script from "./GooglePlayChannels.vue?vue&type=script&lang=js"
export * from "./GooglePlayChannels.vue?vue&type=script&lang=js"
import style0 from "./GooglePlayChannels.vue?vue&type=style&index=0&id=3b5a29f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b5a29f6",
  null
  
)

export default component.exports